import { jsx as c, jsxs as n } from "react/jsx-runtime";
import { c as i } from "../index-rKuIKazb.js";
import l from "../IconLookup/index.js";
import { useTheme as m } from "../ThemeProvider/index.js";
import '../assets/index24.css';/*!
 * Font Awesome Pro 6.7.1 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license (Commercial License)
 * Copyright 2024 Fonticons, Inc.
 */
const u = {
  prefix: "far",
  iconName: "circle-check",
  icon: [512, 512, [61533, "check-circle"], "f058", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L369 209z"]
}, f = "_layout_cgpz3_2", _ = "_featureContainer_cgpz3_7", p = "_feature_cgpz3_7", d = "_icon_cgpz3_16", h = "_dark_cgpz3_20", e = {
  layout: f,
  featureContainer: _,
  feature: p,
  icon: d,
  dark: h
}, g = (o) => {
  const { className: t, features: r } = o, s = m();
  return /* @__PURE__ */ c("div", { className: i(e[s], e.layout, t), children: r.map((a) => /* @__PURE__ */ n("div", { className: e.featureContainer, children: [
    /* @__PURE__ */ c(l, { className: e.icon, iconX: u }),
    /* @__PURE__ */ c("div", { className: e.feature, children: a })
  ] }, a)) });
};
export {
  g as default
};
